const FavoriteQueryKey = {
  FAVORITE: 'FAVORITE',
};

export default FavoriteQueryKey;
